export default __webpack_public_path__ + "static/media/icons-user-group-green-32-px.1d9c5b00.svg";